
export const tileNames = {
	TEXT: { name: "Text", icon: "Text" },
	IMAGE: { name: "Image", icon: "Image" },
	VIDEO: { name: "Video", icon: "Video" },
	TABLE: { name: "Table", icon: "Table" },
	CODE: { name: "Code", icon: "Code" },
	WEB: { name: "Web", icon: "Web" },
	TWITTER: { name: "Twitter", icon: "Twitter" },
	GIPHY: { name: "Giphy", icon: "Giphy" },
	AIRTABLE: { name: "Airtable", icon: "Airtable" },
	FIGMA: { name: "Figma", icon: "Figma" },
	COLOR: { name: "Color", icon: "PaintBucket" },
};

export const textBlockType = {
	P: "p",
	LI: "li",
	H1: "h1",
	H2: "h2",
	H3: "h3",
};